import { Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';

import { Home } from './main/home/home';
import { Gallery } from './main/gallery/gallery';
import { InternalBase } from './internal/internal-base/internal-base';

import { InternalDashboard } from './internal/internal-dashboard/internal-dashboard';
import { InternalTodos } from './internal/internal-todos/internal-todos';
import { InternalPresence } from './internal/internal-presence/internal-presence';
import { InternalRequests } from './internal/internal-requests/internal-requests';
import { InternalEvents } from './internal/internal-events/internal-events';
import { InternalSongRequests } from './internal/internal-songrequests/internal-songrequests';
import { InternalPresenceEdit } from './internal/internal-presence-edit/internal-presence-edit';
import { InternalGallery } from './internal/internal-gallery/internal-gallery';
import { InternalSettings } from './internal/internal-settings/internal-settings';
import { InternalUsers } from './internal/internal-users/internal-users';
import { InternalFinances } from './internal/internal-finances/internal-finances';
import { InternalInvoiceEditor } from './internal/internal-invoice-editor/internal-invoice-editor';
import { InternalInventory } from './internal/internal-inventory/internal-inventory';
import { DocumentViewer } from './main/document-viewer/document-viewer';
import { SongRequestForm } from './main/song-request-form/song-request-form';
import { Oauth } from './main/oauth/oauth';
import { RequestForm } from './main/request-form/request-form';
import { PageNotFound } from './page-not-found/page-not-found';
import { InternalBaseWorkstation } from './internal/internal-base-workstation/internal-base-workstation';
import { Events } from './main/events/events';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: Home },
  { path: 'gallery', component: Gallery },

  { path: 'music', component: SongRequestForm, data: { hideHeader: true } },
  { path: 'request', component: RequestForm },
  { path: 'events', component: Events },
  { path: 'document/:docid', component: DocumentViewer },
  {
    path: 'internal',
    component: InternalBase,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    data: { hideFooter: true },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: InternalDashboard },
      { path: 'todos', component: InternalTodos },
      { path: 'presence', component: InternalPresence },
      { path: 'presence/:presenceid', component: InternalPresenceEdit },
      { path: 'requests', component: InternalRequests },
      { path: 'events', component: InternalEvents },
      { path: 'songrequests', component: InternalSongRequests },
      { path: 'gallery', component: InternalGallery },
      { path: 'inventory', component: InternalInventory },
      { path: 'finances', component: InternalFinances },
      { path: 'invoice', component: InternalInvoiceEditor },
      { path: 'users', component: InternalUsers },
      { path: 'settings', component: InternalSettings },
      { path: '**', redirectTo: '/not-found' },
    ],
  },
    { path: 'workstation', component: InternalBaseWorkstation, data: {hideHeader: true, hideFooter: true}, canActivate: [AuthGuardService], canActivateChild: [AuthGuardService], children: [
        { path: '', redirectTo: 'todos', pathMatch: 'full'},
        { path: 'dashboard', component: InternalDashboard},
        { path: 'presence', component: InternalPresence},
        { path: 'presence/:presenceid', component: InternalPresenceEdit},
        { path: 'todos', component: InternalTodos },
        { path: 'inventory', component: InternalInventory},
    ]},

  {
    path: 'oauth',
    data: { hideHeader: true, hideFooter: true },
    children: [
      { path: 'login', component: Oauth },
      { path: '**', redirectTo: '/not-found' },
    ],
  },

  { path: '**', component: PageNotFound },
];
